import * as yup from 'yup'

export const schemaCreateSubcontractModal = yup.object().shape({
    subcontract_code: yup.string().required(),
    subcontract_name: yup.string().required('subcontract-name-validate'),
    subcontract_effective_date: yup.string().required(),
    subcontract_expiry_date: yup.string().required(),
})
